<template>
  <v-text-field
    outlined
    v-bind="computedProps"
    v-on="$listeners"
    :type="showPassword ? 'text' : 'password'"
    prepend-icon="fa-key"
    :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
    @click:append="showPassword = !showPassword"
  ></v-text-field>
</template>

<script>
import { VTextField } from "vuetify/lib";
export default {
  name: "SPasswordField",
  extends: VTextField,
  props: {
    label: {
      type: String,
      default: "Mot de passe",
    },
    color: {
      type: String,
      default: "primaryColor",
    },
  },
  data: () => ({
    showPassword: false,
  }),
  computed: {
    computedProps() {
      return {
        ...this.$props,
        label: this.label,
        color: this.color,
      };
    },
  },
};
</script>

<style></style>
